import { SuratJalanStatus } from "../types/suratJalan";

export const SURAT_JALAN_WORKFLOW_STEP_KEYS = [
  SuratJalanStatus.IN_REVIEW,
  SuratJalanStatus.INVOICING_REVIEW,
  SuratJalanStatus.REVISION_REQUIRED,
  SuratJalanStatus.APPROVED,
] as const;

export const getSuratJalanWorkflowStepKey = (status: SuratJalanStatus | string): string => status;
